const prodHelpers = require('./isProd');

const isProdEnvironment = prodHelpers.isProd(window.location.origin, prodHelpers.prodPartials);
if (isProdEnvironment) {
  module.exports = require('./oktaConfig.prod');
} else {
  module.exports = require('./oktaConfig.dev');
}
